import { render, staticRenderFns } from "./LayerAdd.vue?vue&type=template&id=44437b56&"
import script from "./LayerAdd.vue?vue&type=script&lang=js&"
export * from "./LayerAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports